import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import Loader from '../../components/common/Loader';

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalProducts: 0,
    totalCategories: 0,
    totalOrders: 0,
    totalCustomers: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [productsRes, categoriesRes] = await Promise.all([
        api.get('/admin/products'),
        api.get('/admin/categories')
      ]);

      setStats({
        totalProducts: productsRes.data.count || 0,
        totalCategories: categoriesRes.data.count || 0,
        totalOrders: 0, // Will implement later
        totalCustomers: 0 // Will implement later
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader fullscreen />;

  return (
    <div>
      

      <div className="dashboard-stats">
        <div className="stat-card">
          <div className="stat-icon blue">📦</div>
          <div className="stat-info">
            <h3>{stats.totalProducts}</h3>
            <p>პროდუქტები ჯამში</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon purple">📁</div>
          <div className="stat-info">
            <h3>{stats.totalCategories}</h3>
            <p>კატეგორიები</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon green">🛒</div>
          <div className="stat-info">
            <h3>{stats.totalOrders}</h3>
            <p>შეკვეთები</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;